<template>
    <div class="app-wrapper">
        <app-header class="header" />
        <app-main class="app-main" />
        <app-footer class="footer" />
    </div>
</template>

<script>
import { AppMain } from './components'
import header from '@/layout/components/header'
import footer from '@/layout/components/footer'
export default {
    name: 'Layout',
    components: {
        appHeader: header,
        appFooter: footer,
        AppMain,
    },
}
</script>

<style lang="scss" scoped>
.app-wrapper {
    width: 24rem;
    position: relative;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    min-width: 17.5rem;
    overflow-x: auto;
    margin: 0 auto;
    overflow: hidden;
    .header {
        position: fixed;
        z-index: 100;
    }
    .app-main {
        flex-grow: 1;
    }
}
</style>
